/*
  The reference shows every filter group expanded at once — one scrolling
  column of headings and value boxes, no accordion. Dawn ships each group as a
  closed <details>, and "open" is markup state, not something CSS can set, so
  it is opened here.

  Dawn re-renders the drawer through the Section Rendering API on every facet
  change, which replaces these nodes and drops the attribute, so the observer
  re-applies it rather than running once on load.
*/
(() => {
  const openAll = (root) => {
    root.querySelectorAll('.mobile-facets__details:not([open])').forEach((d) => {
      d.setAttribute('open', '');
      const summary = d.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });
  };

  const start = () => {
    const wrapper = document.querySelector('#main-collection-filters');
    if (!wrapper) return;

    openAll(wrapper);

    /*
      Two things reopen the groups after the initial pass: Dawn collapses them
      whenever the drawer itself is toggled, and it swaps the whole subtree for
      freshly rendered markup after each facet change. Watching `toggle` covers
      the first (it fires on the drawer's own <details> too, which is harmless)
      and the observer covers the second.
    */
    wrapper.addEventListener('toggle', () => openAll(wrapper), true);

    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('.mobile-facets__details')) {
            node.setAttribute('open', '');
          }
          openAll(node);
        }
      }
      openAll(wrapper);
    }).observe(wrapper, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
